import { useQueryClient } from 'react-query';
import useHttpMutation from '@actions/services/firestore/browser/useHttpMutation';
import type {
    CreateCustomCostProviderRequest,
    CreateCustomCostProviderResponse,
    UseCreateCustomCostProviderParams,
    UseCreateCustomCostProviderResult,
} from './types';

const useCreateCustomCostProvider = ({
    onSuccess,
    onError,
}: UseCreateCustomCostProviderParams): UseCreateCustomCostProviderResult => {
    const queryClient = useQueryClient();

    const { mutate, isLoading } = useHttpMutation<
        CreateCustomCostProviderRequest,
        CreateCustomCostProviderResponse
    >({
        method: 'POST',
        pathname: '/admin/platform-costs/custom-providers',
        onSuccess: response => {
            queryClient.invalidateQueries([
                'admin-platform-costs-custom-providers',
                response.data.provider.month,
            ]);
            onSuccess({
                providerId: response.data.provider.id,
                month: response.data.provider.month,
            });
        },
        onError: error => onError(error),
    });

    return {
        createProvider: ({ displayName, month }) => {
            mutate({
                body: {
                    displayName,
                    month,
                },
            });
        },
        isCreatingProvider: isLoading,
    };
};

export default useCreateCustomCostProvider;
